import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Row, Button, Badge } from 'reactstrap';
import ReactTable from 'react-table';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import DataTablePagination from '../../../../components/DatatablePagination';
import { Card, CardBody, CardTitle } from 'reactstrap';
import IntlMessages from '../../../../helpers/IntlMessages';
import {
    reactSelectOptionDiffrentPro
} from '../../../../helpers/Utils';
import {
    gAPI_MissedResponseList,
    postAPI_TrackEvent, gAPI_Users_By_Id
} from '../../../../constants/APIs';
import { AxiosAPI, getGroupID, getUserID } from '../../../../helpers/AxiosAPI';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UpdateStatus from './Components/UpdateStatus';
import ConversationPopup from './Components/ConversationPopup';
const dataTableColumns = [
    {
        Header: 'Missed Question',
        accessor: 'missedQuestion',
        style: { width: "150px !important" },
        Cell: (props) => <p className="wrap-pragraaph">{props.value}</p>,
    },
    // {
    //     Header: 'Question',
    //     accessor: 'questionAsked',
    //     Cell: (props) => <p className="">{props.value}</p>,
    // },
    {
        Header: 'Conversation Summary',
        accessor: 'responseGiven',
        style: { width: "150px !important" },
        Cell: (props) => <p className="wrap-pragraaph">{props.value}</p>,
    },
    {
        Header: 'Timestamp',
        accessor: 'createdDate',
        Cell: (props) => <p className="">{moment(props.value).format(
            'ddd, MMM DD YYYY hh:mm a'
        )}</p>,
    },
    {
        Header: 'Status',
        accessor: 'currentStatus',
        Cell: (props) => (
            <div className="ml-4"> <Badge color="warning">{props.value === "Ignored" ? "Ignore" : props.value}</Badge>
                {props.value !== "Open" &&
                    <span><br />{props.original.statusUpdatedBy} On <br />
                        {moment(props.original.statusUpdateUtc).format(
                            'MMM DD YYYY hh:mm a'
                        )}</span>}
            </div>
        ),
    },
    {
        Header: 'Update Status',
        accessor: 'currentStatus',
        Cell: (props) => (
            <div className="ml-2">
                {props.value !== "Updated" && props.value !== "Ignored" ?
                    <UpdateStatus id={props.original.id} value={"Updated"}></UpdateStatus> : ""}
                {props.value !== "Ignored" && <UpdateStatus id={props.original.id} value={"Ignore"}></UpdateStatus>}
            </div>)
    },
    {
        Header: '',
        accessor: 'conversationId',
        Cell: (props) => (
            <div className="ml-2">
                <ConversationPopup conversationid={props.value}></ConversationPopup>
            </div>)
    }
];
const statusList = [
    { label: "Open", value: "Open" },
    { label: "Updated", value: "Updated" },
    { label: "Ignored", value: "Ignored" },
];

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            isLoading: true,
            isFiltering: false,
            selectedStatus: [{ label: "Open", value: "Open" }],
            filteredData: [],
            startDate: moment().subtract(29, 'days'),
            endDate: moment(),
            statusFilter: [],
        };
    }

    componentDidMount() {
        var filterStatusList = [];
        statusList.map((l) => filterStatusList.push({ ...l, checked: false }));
        this.setState({ statusFilter: filterStatusList });

        if (this.props.email !== '') {
            AxiosAPI({
                method: 'post',
                url: `${postAPI_TrackEvent}`,
                data: {
                    eventName: 'Dashboard Users and Admin',
                    email: this.props.email,
                },
            }).then(
                (res) => { },
                (error) => {
                    console.log(error);
                }
            );
        }
        this.LoadData("Open", this.state.startDate, this.state.endDate);
    }

    LoadData = (status, startdate, enddate) => {
        const start = moment(startdate).format('YYYY-MM-DD') + ' 00:00:00';
        const end = moment(enddate).format('YYYY-MM-DD') + ' 23:59:59';
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_MissedResponseList}?groupId=${getGroupID()}&propertyId=${this.props.propertyId}&dateFrom=${start}&dateTo=${end}&status=${status}`,
        }).then(
            (res) => {
                this.setState((state) => ({
                    data: res.data,
                    isLoading: false,
                }));
            },
            (error) => {
                this.setState({ loading: false, error, isLoading: false });
            }
        );
    }
    handleChangeDate = (date) => {
        this.setState({
            startDate: date,
        });
    };

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        });
    };
    handleChangeSelect = (value, { name }) => {
        if (name === "status") {
            var m = this.state.statusFilter.map((elem) => {
                value.map((sel) => {
                    if (sel.value.toLowerCase() === elem.value.toLowerCase()) {
                        elem.checked = true;
                    }
                });
                return elem;
            });
            this.setState({
                selectedStatus: value,
                statusFilter: m,
            });
        }
    }
    handleSubmitClick = () => {
        this.setState({ isLoading: true });
        this.LoadData(this.state.selectedStatus.length > 0 ? this.state.selectedStatus.map((a) => a.value).join('|') : '-1', this.state.startDate, this.state.endDate);
        this.setState((state) => ({
            isFiltering: false,
        }));
    }

    render() {
        const { startDate, endDate } = this.state;
        return (
            <Fragment>
                <div className="mb-2">
                    <Row>
                        <div className=" d-inline-block  mt-2">
                            <Button
                                size="xs"
                                color="primary"
                                className=""
                                onClick={() => this.setState({ isFiltering: !this.state.isFiltering })}
                            >
                                <div className='d-flex'>
                                    <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />
                                    <IntlMessages id="menu.show-filter" />
                                    <div className='ml-1' style={{ marginTop: "2px" }}>
                                        {this.state.isFiltering ?
                                            <i className='simple-icon-arrow-up p-1'></i> :
                                            <i className='simple-icon-arrow-down p-1'></i>
                                        }
                                    </div>
                                </div>
                            </Button>
                        </div>
                    </Row>
                </div>
                <Colxx xxs="12" className="mb-2 text-right">
                    <strong><hr /></strong>
                </Colxx>
                {this.state.isFiltering && (
                    <Card className="filter-width mt-2" style={{ position: "absolute", zIndex: "1", top: "7rem", marginLeft: "0rem", boxShadow: "0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)" }}>
                        <CardBody >

                            <Colxx md="12" >
                                <Row>
                                    <Colxx xxs="12" md="12" className="mb-2">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={this.handleChangeDate}
                                            placeholderText="Start Date"
                                            dateFormat="DD/MM/YYYY"
                                        />
                                    </Colxx>
                                    <Colxx xxs="12" md="12" className="mb-2">
                                        <DatePicker
                                            selected={endDate}
                                            onChange={this.handleChangeEndDate}
                                            placeholderText="End Date"
                                            dateFormat="DD/MM/YYYY"
                                        />
                                    </Colxx>
                                    <Colxx xxs="12" md="12" className=" mb-2">
                                        <Select
                                            isMulti={true}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            name="status"
                                            placeholder="Status"
                                            onChange={this.handleChangeSelect}
                                            options={
                                                statusList
                                                    ? reactSelectOptionDiffrentPro(
                                                        statusList,
                                                        true,
                                                        'value',
                                                        'label',
                                                        'Select Status'
                                                    )
                                                    : []
                                            }
                                            value={this.state.selectedStatus}
                                        />
                                    </Colxx>
                                    <Colxx xxs="12" md="12" >
                                        <Button size={"xs"}
                                            color="primary"
                                            className="mb-2 mt-2"
                                            onClick={() => this.handleSubmitClick()}>
                                            Search
                                        </Button>
                                        <Button
                                            size="xs"
                                            color="secondary"
                                            className="mb-2 ml-2 mt-2"
                                            onClick={() => this.setState({ isFiltering: false })}
                                        >
                                            Cancel
                                        </Button>

                                    </Colxx>
                                </Row>
                            </Colxx>
                        </CardBody>
                    </Card>
                )}
                <Colxx xxs="12" className="mb-2">
                    <Fragment>

                        <Card className="mb-2">
                            <CardBody>
                                {!this.state.isLoading && this.state.data ? (
                                    <ReactTable
                                        data={this.state.data}
                                        columns={dataTableColumns}
                                        defaultPageSize={this.state.itemsPerPage}
                                        filterable={false}
                                        showPageJump={true}
                                        PaginationComponent={DataTablePagination}
                                        showPageSizeOptions={true}
                                        defaultSorted={[
                                            {
                                                id: 'createdDate',
                                                desc: true,
                                            },
                                        ]}
                                    />
                                ) : (
                                    <div className="loading" />
                                )}
                            </CardBody>
                        </Card>
                    </Fragment>
                </Colxx>
            </Fragment>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, email } = settings;
    return {
        propertyId,
        email,
    };
};
export default injectIntl(
    connect(mapStateToProps, {})(Index)
);
